"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.broadcastTypesMap = exports.WEBINAR = exports.STUDIO_LITE = exports.STUDIO_ADVANCED = void 0;
var STUDIO_ADVANCED = exports.STUDIO_ADVANCED = 'Studio Advanced';
var STUDIO_LITE = exports.STUDIO_LITE = 'Studio Lite';
var WEBINAR = exports.WEBINAR = 'Webinar';
var broadcastTypesMap = exports.broadcastTypesMap = new Map([['webinar', WEBINAR], ['diy_embedded', STUDIO_LITE], ['diy', STUDIO_ADVANCED]]);